import React from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl, SegmentedControlItem, SegmentedControlItemBar } from '@helix/segmented-control';

const HelixSegmentedControl = ({ setOption, optionsList, defaultOption, size="medium" }) => {
    const options = optionsList.map((option, i) => (
        <SegmentedControlItem
            key={i}
            eventKey={option.value}
            onClick={() => setOption(option.value)}
        >
            <span className="toggle-item">{option.label}</span>
        </SegmentedControlItem>
    ));

    return (
        <SegmentedControl
            defaultActiveKey={defaultOption}
            size={size}
        >
            <SegmentedControlItemBar>{options}</SegmentedControlItemBar>
        </SegmentedControl>
    );
};

HelixSegmentedControl.propTypes = {
    setOption: PropTypes.func.isRequired,
    optionList: PropTypes.array,
    defaultOption: PropTypes.string,
    size: PropTypes.string
};

export default HelixSegmentedControl;
